/*@jsxRuntime automatic @jsxImportSource react*/
import {Fragment as _Fragment, jsx as _jsx, jsxs as _jsxs} from "react/jsx-runtime";
import LandingPageLayout from '../../components/layouts/LandingPageLayout';
import LarsBerton from '/public/static/lars_berton.jpg';
import Image from 'next/image';
export const meta = {
  author: 'Lars Berton'
};
const MDXLayout = ({children}) => _jsx(LandingPageLayout, {
  mdx: true,
  meta: meta,
  title: "Lars sine topp tre undervisningstips",
  subTitle: "Tre undervisningstips fra superunderviser Lars fra Nord universitet",
  children: children
});
function MDXContent(props = {}) {
  return MDXLayout ? _jsx(MDXLayout, Object.assign({}, props, {
    children: _jsx(_createMdxContent, {})
  })) : _createMdxContent();
  function _createMdxContent() {
    const _components = Object.assign({
      h2: "h2",
      strong: "strong",
      p: "p",
      h3: "h3"
    }, props.components);
    return _jsxs(_Fragment, {
      children: [_jsx(Image, {
        src: LarsBerton
      }), "\n", _jsx(_components.h2, {
        children: _jsx(_components.strong, {
          children: "Om Lars"
        })
      }), "\n", _jsx(_components.p, {
        children: "Lars underviser i anatomi, fysiologi og biokjemi på sykepleiestudiet ved Nord universitet, Campus Levanger. Høsten 2020 byttet han ut monologbaserte forelesninger med digital teambasert læring. Til tross for koronarestriksjoner, digital undervisning og en unormal eksamen gjorde studentene hans bedre på eksamen sammenlignet med tidligere studenter som hadde fulgt tradisjonelle forelesninger."
      }), "\n", _jsx(_components.h2, {
        children: _jsx(_components.strong, {
          children: "Lars sine topp tre undervisningstips."
        })
      }), "\n", _jsx(_components.h3, {
        children: _jsx(_components.strong, {
          children: "1. Undervis om undervisningen din"
        })
      }), "\n", _jsx(_components.p, {
        children: "Jeg starter alltid første dag med å undervise om undervisningen. En åpenbar fordel med det er at studentene får innblikk i hvordan undervisningen foregår rent praktisk. Men enda viktigere er det at jeg forklarer hvorfor undervisningen er lagt opp slik den er, med henvisning til forskning på hvordan hjernen lærer best. På denne måten får jeg solgt inn budskapet fra første dag og får studentene «om bord» på undervisningen min."
      }), "\n", _jsx(_components.h3, {
        children: _jsx(_components.strong, {
          children: "2. Skap studentaktiv læring med en tydelig struktur"
        })
      }), "\n", _jsx(_components.p, {
        children: "Dette kan gjøres ved å lage en læringssti eller studieguide. Litt metaforisk sier jeg til studentene at «jeg skal tråkke opp stien og vise de veien, men at de må gå selv». Studentaktiv læring kommer ikke av seg selv. Derfor er viktig at du som underviser legger til rette for studentaktiv læring. Ved bruk av teknologi, slik som curipod, kan man stimulere til diskusjon og refleksjon. En ryddig læringssti gjør det dessuten enkelt for studentene å navigere i emnet slik at deres kognitive kapasitet kan brukes til å lære seg faget."
      }), "\n", _jsx(_components.h3, {
        children: _jsx(_components.strong, {
          children: "3. Vær en «programleder»"
        })
      }), "\n", _jsx(_components.p, {
        children: "Vær kreativ og by på deg selv. Jeg vet det er en klisjé, men å opptre litt uortodoks i undervisningsrollen fanger oppmerksomheten til studentene dine og ikke minst minker avstanden mellom deg og studentene. Dette er viktig for å skape et trygt læringsmiljø hvor studenter ikke er redde for å spørre og undre i felleskap. I en emneevaluering gjort av mine studenter beskrev én student meg som «en programleder i beste sendetid». Hva venter du på? Ta på deg programleder-hatten og by på deg selv!"
      })]
    });
  }
}
export default MDXContent;
